import React from 'react';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { Section, ImageSection, TextSection } from '../../styles/Section';
import { StyledTypography } from '../../styles/Typography';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionCard() {
  return (
    <Section>
      <ImageSection>
        <FormattedMessage id="FGTS.CARD.ALT_IMAGE">
          {([alt]) => (
            <ResponsiveImages
              fileName="2-cards/2-cards.jpg"
              alt={alt}
              width="535px"
              loading="lazy"
            />
          )}
        </FormattedMessage>
      </ImageSection>
      <TextSection>
        <StyledTypography
          variant="title"
          intlKey="FGTS.CARD.TITLE"
        />
        <StyledTypography
          variant="subtitle"
          intlKey="FGTS.CARD.SUBTITLE"
        />
      </TextSection>
    </Section>
  );
}

export default React.memo(SectionCard);
